import React from "react";
import { Link } from "react-router-dom";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Hidden from "@material-ui/core/Hidden";
import Button from "components/CustomButtons/Button.jsx";
import WarningIcon from "@material-ui/icons/Warning";

import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle";

class HeaderLinks extends React.Component {
  state = {
    open: false
  };
  handleToggle = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };

  render() {
    const { classes, routes } = this.props;
    
    // Find the "Renew License" route if it exists
    const renewLicenseRoute = routes && routes.find(
      route => route.sidebarName === "Renew License"
    );

    if (!renewLicenseRoute) {
      return <div className={classes.links} />;
    }

    return (
      <div style={{ 
        display: "flex", 
        alignItems: "center",
        overflow: "visible",
        flexShrink: 0
      }}>
        <Link to={renewLicenseRoute.path} style={{ textDecoration: "none", flexShrink: 0 }}>
          <Button
            color="warning"
            size="sm"
            style={{
              marginRight: "10px",
              fontWeight: "bold",
              backgroundColor: "rgba(255, 152, 0, 0.9)",
              border: "1px solid #ff9800",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
              whiteSpace: "nowrap",
              fontSize: "12px",
              padding: "6px 10px",
              minWidth: "auto",
              height: "auto",
              lineHeight: "1.2",
              display: "flex",
              alignItems: "center",
              flexShrink: 0
            }}
          >
            <WarningIcon style={{ 
              marginRight: "4px", 
              fontSize: "16px",
              flexShrink: 0
            }} />
            <Hidden xsDown>
              <span style={{ flexShrink: 0 }}>Renew License</span>
            </Hidden>
            <Hidden smUp>
              <span style={{ flexShrink: 0 }}>Renew</span>
            </Hidden>
          </Button>
        </Link>
      </div>
    );
  }
}

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx